import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {Banner} from '../src/components/Banner';
import {Footer} from '../src/components/Footer';
import { ReworthDirectory } from '@reworthrewards/directory-react-component';

/* import { Travel } from './components/Travel'; 
	<h4 className="subtitleCarusel">¿Estás listo para obtener recompensas increíbles?</h4>
	<Travel />
*/

const App = () => {
	const location = useLocation();
	const fiid = process.env.REACT_APP_FIID ?? "";
	const isRootPath = location.pathname === '/';
	const [isLoading, setIsLoading] = useState(true);
	const reworthDirectoryRef = useRef(null);
	const [loadingDivHeight, setLoadingDivHeight] = useState('auto');

	const calculateHeight = () => {
		const footer = document.querySelector('.footer');
		const windowHeight = window.innerHeight;

		let footerHeight = footer?.offsetHeight || 0;
	
		if (footer) {
		  const footerStyles = window.getComputedStyle(footer);
		  const footerMarginTop = parseFloat(footerStyles.marginTop) || 0;
		  const footerMarginBottom = parseFloat(footerStyles.marginBottom) || 0;
		  footerHeight += footerMarginTop + footerMarginBottom;
		}
	
		const dynamicHeight = windowHeight - footerHeight;
		setLoadingDivHeight(dynamicHeight);
	  };
	
	  useEffect(() => {
		calculateHeight();
		window.addEventListener('resize', calculateHeight);
	
		return () => {
		  window.removeEventListener('resize', calculateHeight);
		};
	  }, []);
	
	useEffect(() => {
	  const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
		  if (mutation.addedNodes.length > 0) {
			setIsLoading(false);
			observer.disconnect();
		  }
		});
	  });
  
	  if (reworthDirectoryRef.current) {
		observer.observe(reworthDirectoryRef.current, { childList: true, subtree: true });
	  }
  
	  return () => observer.disconnect();
	}, [reworthDirectoryRef]);
  
  
	return (
		<div id="root">
		  <div className="main-content">
			{isRootPath && (
			  <div>
				<Banner/>
			  </div>
			)}
			<div ref={reworthDirectoryRef}>
			{isLoading && (
            <div style={{ height: loadingDivHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            </div>
          )}			  <ReworthDirectory
				accentColor="#3743AA"
				env="prod"
				skin="ALBO"
				fiid={fiid}
				fontFamily="Muli"
				gtm
			  />
			</div>
		  </div>
		  {!isLoading && <Footer className="footer" />}
		</div>
	  );
	};
	

export default App
